import { Card, CardContent, Typography, Box, Rating } from '@mui/material';
import type { BrandScore } from '../utils/riskAssessment';

interface BrandScoreCardProps {
    brand: BrandScore;
}

export const BrandScoreCard = ({ brand }: BrandScoreCardProps) => {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Brand Deal Potential
                </Typography>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Rating value={brand.tier} max={5} readOnly size="large" />
                    <Typography variant="subtitle1">{brand.label}</Typography>
                </Box>
                <Typography variant="body2" color="textSecondary">
                    {brand.reasoning}
                </Typography>
            </CardContent>
        </Card>
    );
};
